import { ListItem, styled } from '@mui/material';

export const ListItemStyled = styled(ListItem)({
  padding: '0',
  marginBottom: '8px',
});
